import FlightIcon from "@mui/icons-material/Flight";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import moment from "moment";

import { ReactComponent as Arrow } from "assets/images/arrow.svg";
import { ReactComponent as Cabinbaggage } from "assets/images/cabinbaggage.svg";
import { ReactComponent as Dot } from "assets/images/dot.svg";

import { capitalizeFirstLetter } from "utils/Utils";

import Badge from "../badge";

import { checkISAdminOrEmployee, duration, timeDiffCalc } from "utils/Utils";

import { getUserFromLocalStorage } from "hooks/LocalStorage";
const ItineraryComponent = ({
  itinerary,
  segment,
  dictionaries,
  flight,
  destinationLocationCode,
  originLocationCode,
  index,
  hideClass,
  isScreenShot,
}) => {
  const getAirlineLogo = (carrierCode) => {
    let logo;

    const airlineLogos = dictionaries?.airlineLogos;

    if (airlineLogos && airlineLogos[carrierCode]) {
      logo =
        airlineLogos[carrierCode][0]?.squareImage ||
        airlineLogos[carrierCode][0]?.tailImage;
    }

    return logo;
  };

  return (
    <>
      <div className="result-card-content">
        <p className="result-card-time">
          {moment(segment?.departure?.at).format("ddd D MMM")}
        </p>
        <div>
          <div className="result-card-slice-title">
            <div className="arrow-wrapper">
              <div className="arrow"></div>
              <Dot />
            </div>
            {dictionaries?.locations && (
              <div className="result-card-place">
                <strong>
                  <time>{moment(segment?.departure?.at).format("H:mm")}</time>{" "}
                  <span>
                    {
                      dictionaries?.locations[segment?.departure?.iataCode]
                        ?.city
                    }
                  </span>{" "}
                </strong>
                <div className="gray-color">
                  {dictionaries?.locations[segment.departure.iataCode]?.airport}
                  {", "}
                  {dictionaries?.locations[segment.departure.iataCode]?.country}
                </div>
              </div>
            )}
          </div>
          <div className="result-card-slice-title">
            <div className="arrow-wrapper">
              <div className="arrow"></div>
              <div className="trip-icon">
                <Arrow />
              </div>

              <div className="arrow bottom"></div>
            </div>
            <div className="badges">
              <Badge
                title={duration(segment?.duration, itinerary?.duration)}
                className="teal"
              />

              {getAirlineLogo(segment?.carrierCode) && (
                <Tooltip
                  title={capitalizeFirstLetter(
                    dictionaries?.carriers[segment?.carrierCode],
                  )}
                  arrow
                  placement="top"
                >
                  <Box
                    sx={{
                      borderRadius: "8px",
                      border: "1px solid rgb(232, 237, 241)",
                      mb: 0.5,
                      mr: 0.5,
                      height: "26px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      className="results-card-logo"
                      src={getAirlineLogo(segment?.carrierCode)}
                    />
                  </Box>
                </Tooltip>
              )}
              <Badge
                title={segment?.carrierCode + segment?.number}
                Icon={FlightIcon}
              />

              <Badge
                title={
                  flight?.travelerPricings[0]?.fareDetailsBySegment?.find(
                    (sege) => sege?.segmentId == segment?.id,
                  )?.cabin
                }
              />

              <Badge
                title={`${
                  flight?.travelerPricings[0]?.fareDetailsBySegment?.find(
                    (fare) => fare.segmentId === segment?.id,
                  )?.includedCheckedBags?.quantity
                    ? flight?.travelerPricings[0]?.fareDetailsBySegment?.find(
                        (fare) => fare.segmentId === segment?.id,
                      )?.includedCheckedBags?.quantity
                    : flight?.travelerPricings[0]?.fareDetailsBySegment?.find(
                          (fare) => fare.segmentId === segment?.id,
                        )?.includedCheckedBags?.weight
                      ? 1
                      : 0
                }x `}
                Icon={Cabinbaggage}
                className={`blue ${
                  flight?.travelerPricings[0]?.fareDetailsBySegment?.find(
                    (fare) => fare.segmentId === segment?.id,
                  )?.includedCheckedBags?.quantity === 0
                    ? "blink"
                    : "unblink"
                }`}
              />
              {(checkISAdminOrEmployee() ||
                getUserFromLocalStorage()?.type === "B_AGENT") &&
                !hideClass && (
                  <Badge
                    title={
                      flight?.travelerPricings[0]?.fareDetailsBySegment?.find(
                        (sege) => sege?.segmentId == segment?.id,
                      )?.class
                    }
                    className="teal"
                  />
                )}
            </div>
          </div>
          {/* Technical stops */}
          {segment?.stops &&
            segment.stops.length > 0 &&
            segment.stops.map((stop, stopIdx) => (
              <Box
                key={`stop-${stopIdx}`}
                sx={{
                  mt: 0.75,
                  ml: "22px",
                  py: "3px",
                  px: 1,
                  borderRadius: "20px",
                  background:
                    "linear-gradient(135deg, rgba(237,108,2,0.07) 0%, rgba(237,108,2,0.03) 100%)",
                  border: "1px solid rgba(237,108,2,0.18)",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.75,
                  maxWidth: "fit-content",
                }}
              >
                <FlightIcon
                  sx={{
                    width: 11,
                    height: 11,
                    color: "#e65100",
                    transform: "rotate(180deg)",
                    flexShrink: 0,
                  }}
                />
                <span
                  style={{
                    fontSize: "0.6rem",
                    fontWeight: 700,
                    color: "#fff",
                    background: "linear-gradient(135deg, #f57c00, #e65100)",
                    borderRadius: "10px",
                    padding: "1px 7px",
                    letterSpacing: "0.3px",
                    textTransform: "uppercase",
                    lineHeight: 1.6,
                  }}
                >
                  Stop
                </span>
                <span
                  style={{
                    fontSize: "0.62rem",
                    fontWeight: 600,
                    color: "#37474f",
                    letterSpacing: "0.1px",
                  }}
                >
                  {dictionaries?.locations?.[stop.iataCode]?.city ||
                    stop.iataCode}
                </span>
                <span
                  style={{
                    fontSize: "0.58rem",
                    color: "#78909c",
                    fontWeight: 500,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "2px",
                  }}
                >
                  {duration(stop.duration)}
                </span>
                <span
                  style={{
                    fontSize: "0.58rem",
                    color: "#90a4ae",
                    fontWeight: 500,
                    fontVariantNumeric: "tabular-nums",
                  }}
                >
                  {moment(stop.arrivalAt).format("HH:mm")}–
                  {moment(stop.departureAt).format("HH:mm")}
                </span>
              </Box>
            ))}

          <div className="result-card-slice-title">
            <div className="arrow-wrapper">
              <div className="arrow bottom"></div>
              <Dot />
            </div>
            {dictionaries?.locations && (
              <div className="result-card-place">
                <strong>
                  <time>{moment(segment?.arrival?.at).format("H:mm")}</time>{" "}
                  <span>
                    {dictionaries?.locations[segment?.arrival?.iataCode]?.city}
                  </span>
                </strong>
                <div className="gray-color">
                  {dictionaries?.locations[segment.arrival.iataCode]?.airport}
                  {", "}
                  {dictionaries?.locations[segment.arrival.iataCode]?.country}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {dictionaries?.locations &&
        itinerary?.segments[itinerary?.segments?.length - 1] !== segment &&
        itinerary?.segments?.length > 1 &&
        segment?.arrival?.iataCode !== destinationLocationCode?.split("/")[0] &&
        segment?.arrival?.iataCode !== originLocationCode?.split("/")[0] && (
          <div className="sector-layover">
            <hr />

            <div className="layover-text">
              Layover in{" "}
              {dictionaries?.locations[segment?.arrival?.iataCode]?.country}{" "}
              {timeDiffCalc(
                new Date(segment?.arrival?.at),
                new Date(itinerary?.segments[index + 1]?.departure?.at),
              )}
            </div>
          </div>
        )}
    </>
  );
};

export default ItineraryComponent;
